/* =====================================================
   popup-signup.js  —  Email capture popup
   Subscribes email to Shopify newsletter:
     → Creates/updates Customer with accepts_marketing=true
     → Visible in Shopify Admin → Customers (Email subscriber tag)

   Trigger: shows once per calendar day per visitor, 4s after
   the homepage loads (localStorage key resets automatically
   the next day — no exit-intent, no manual "remember" logic).

   i18n: language is auto-detected from Shopify's country
   auto-detection system (Shopify Markets geolocation), NOT the
   site's manual language selector. Mapping:
     KR (Korea) → Korean
     JP (Japan) → Japanese
     everything else → English (default)
   ===================================================== */
(function () {
  'use strict';

  const CFG = window.__PSP_CONFIG__ || {};
  const STORAGE_PREFIX = CFG.storageKey || 'psp_shown';
  const DELAY           = CFG.delay      || 4000;

  // Show at most once per calendar day (visitor's local date).
  // Key resets automatically the next day — no manual "remember" needed.
  function todayKey() {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${STORAGE_PREFIX}_${y}-${m}-${day}`;
  }
  const DAY_KEY = todayKey();

  // =========================================================
  // i18n — translations keyed by language code
  // Resolved from Shopify's detected country (Markets), not
  // the display-language selector.
  // =========================================================
  const STRINGS = {
    en: {
      headline:     'Claim your SecondBrain<br>Note',
      perk1:        '<b>300 min/month</b> free transcription',
      perk1Icon:    '🎙️',
      perk2:        'Unlimited AI transcription &amp; summary for Genspark members — up to 24h/day.',
      perk2Icon:    '✨',
      perk3:        '<b>Exclusive launch offer:</b> 10% off',
      perk3Icon:    '💰',
      emailPH:      'Enter your email',
      ctaLabel:     'Get My Launch Offer',
      errInvalid:   'Please enter a valid email address.',
      errGeneric:   'Something went wrong. Please try again.',
      successTitle: "You're in! 🎉",
      successMsg:   "You're in! Check your inbox for your offer.",
    },
    ja: {
      headline:     'SecondBrain Note をゲット',
      perk1:        '<b>月300分</b>の無料文字起こし',
      perk1Icon:    '🎙️',
      perk2:        'Genspark会員は最大24時間/日、AIによる文字起こし・要約が無制限。',
      perk2Icon:    '✨',
      perk3:        '<b>期間限定ローンチ特典：</b>10%オフ',
      perk3Icon:    '💰',
      emailPH:      'メールアドレスを入力',
      ctaLabel:     '特典を受け取る',
      errInvalid:   '有効なメールアドレスを入力してください。',
      errGeneric:   '問題が発生しました。もう一度お試しください。',
      successTitle: 'ご登録ありがとうございます！🎉',
      successMsg:   'メールをご確認ください。特典をお届けします。',
    },
    ko: {
      headline:     'SecondBrain Note 받기',
      perk1:        '<b>월 300분</b> 무료 음성 변환',
      perk1Icon:    '🎙️',
      perk2:        'Genspark 멤버는 하루 최대 24시간, AI 음성 변환 및 요약 무제한 이용 가능.',
      perk2Icon:    '✨',
      perk3:        '<b>런칭 특가 혜택:</b> 10% 할인',
      perk3Icon:    '💰',
      emailPH:      '이메일 주소를 입력하세요',
      ctaLabel:     '혜택 받기',
      errInvalid:   '올바른 이메일 주소를 입력해 주세요.',
      errGeneric:   '문제가 발생했습니다. 다시 시도해 주세요.',
      successTitle: '가입이 완료되었어요! 🎉',
      successMsg:   '메일함을 확인해 주세요. 혜택을 보내드렸습니다.',
    },
  };

  // Resolve language from Shopify's detected country code (Markets),
  // e.g. localization.country.iso_code injected as CFG.countryCode.
  const COUNTRY_LANG_MAP = { KR: 'ko', JP: 'ja' };
  const countryCode = (CFG.countryCode || '').toUpperCase();
  const rawLocale = COUNTRY_LANG_MAP[countryCode] || 'en';
  const LANG = STRINGS[rawLocale] || STRINGS.en;
  const T = (key) => LANG[key] || STRINGS.en[key] || key;

  // Don't show if already shown/dismissed/subscribed today
  if (localStorage.getItem(DAY_KEY)) return;

  const overlay = document.getElementById('psp-overlay');
  const modal   = overlay && overlay.querySelector('.psp-modal');
  if (!overlay || !modal) return;

  // ── Render translated content ─────────────────────────
  function renderContent() {
    document.getElementById('psp-title').innerHTML = T('headline');

    const perksEl = document.getElementById('psp-perks');
    perksEl.innerHTML = `
      <li><span class="psp-perk-icon">${T('perk1Icon')}</span> <span>${T('perk1')}</span></li>
      <li><span class="psp-perk-icon">${T('perk2Icon')}</span> <span>${T('perk2')}</span></li>
      <li><span class="psp-perk-icon">${T('perk3Icon')}</span> <span>${T('perk3')}</span></li>
    `;

    const emailInput = document.getElementById('psp-email');
    if (emailInput) emailInput.placeholder = T('emailPH');

    const btnLabelEl = document.getElementById('psp-btn-label');
    if (btnLabelEl) btnLabelEl.textContent = T('ctaLabel');
  }
  renderContent();

  // ── Show / hide ──────────────────────────────────────
  function showPopup() {
    overlay.hidden = false;
    // Trigger transition on next frame
    requestAnimationFrame(() => {
      requestAnimationFrame(() => overlay.classList.add('is-visible'));
    });
    document.body.style.overflow = 'hidden';
  }

  function hidePopup(remember) {
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    setTimeout(() => { overlay.hidden = true; }, 300);
    if (remember) localStorage.setItem(DAY_KEY, '1');
  }

  // ── Delay trigger — shows once per day, 4s after page load ──
  setTimeout(showPopup, DELAY);

  // ── Close button ─────────────────────────────────────
  document.getElementById('psp-close').addEventListener('click', () => hidePopup(true));

  // Click outside modal to close
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) hidePopup(true);
  });

  // ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !overlay.hidden) hidePopup(true);
  });

  // ── Form submission ───────────────────────────────────
  // Submits via Shopify's native {% form 'customer' %} tag (see popup-signup.liquid),
  // which includes Shopify's own anti-bot/CSRF protections. We DO NOT intercept
  // with fetch()/AJAX — Shopify's bot-protection challenge only completes on a
  // real browser form submission. Instead the form posts natively into a hidden
  // <iframe target="psp-iframe-target">, so the page itself never navigates away
  // and we can show a custom success/error state in the popup once it completes.
  const form      = document.getElementById('psp-form');
  const input     = document.getElementById('psp-email');
  const btn       = document.getElementById('psp-submit');
  const btnLbl    = document.getElementById('psp-btn-label');
  const spinner   = document.getElementById('psp-btn-spinner');
  const errEl     = document.getElementById('psp-error');
  const iframeTgt = document.getElementById('psp-iframe-target');

  let submitting = false;

  form.addEventListener('submit', (e) => {
    const email = input.value.trim();

    // Basic client-side validation — block the native submit if invalid
    errEl.hidden = true;
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      e.preventDefault();
      errEl.textContent = T('errInvalid');
      errEl.hidden = false;
      input.focus();
      return;
    }

    // Valid — let the browser submit natively into the hidden iframe.
    submitting = true;
    btn.disabled   = true;
    btnLbl.hidden  = true;
    spinner.hidden = false;

    // Safety net: Shopify may attach an invisible hCaptcha challenge to this
    // form. It normally resolves in well under a second, but if it ever
    // hangs (e.g. network hiccup), don't leave the button stuck forever.
    clearTimeout(submitTimeoutId);
    submitTimeoutId = setTimeout(() => {
      if (!submitting) return;
      submitting = false;
      errEl.textContent = T('errGeneric');
      errEl.hidden = false;
      btn.disabled   = false;
      btnLbl.hidden  = false;
      spinner.hidden = true;
    }, 15000);

    // Fire-and-forget analytics hash (does not block/alter the native submit)
    hashEmail(email).then((hashed) => {
      if (window.dataLayer) {
        window.dataLayer.push({ event: 'newsletter_signup', email_hashed: hashed });
      }
    });
  });
  let submitTimeoutId = null;

  // The iframe fires a 'load' event once (a) it first initializes as blank,
  // and (b) again after the form's native submission completes — at which
  // point Shopify has re-rendered the whole page (with this section) inside
  // the iframe, including a #psp-form-result marker reflecting form.errors /
  // form.posted_successfully?. Ignore the very first load (nothing submitted
  // yet) and only react once `submitting` has been set to true above.
  if (iframeTgt) {
    iframeTgt.addEventListener('load', () => {
      if (!submitting) return; // ignore the initial blank iframe load
      submitting = false;
      clearTimeout(submitTimeoutId);

      let result = null;
      try {
        const doc = iframeTgt.contentDocument || iframeTgt.contentWindow.document;
        result = doc.getElementById('psp-form-result');
      } catch (err) {
        // Cross-origin or inaccessible — assume success (same-origin should
        // always work here since /contact is on the same store domain).
      }

      const status = result ? result.getAttribute('data-result') : 'success';

      if (status === 'error') {
        const msg = (result && result.getAttribute('data-message')) || T('errGeneric');
        errEl.textContent = msg;
        errEl.hidden = false;
        btn.disabled   = false;
        btnLbl.hidden  = false;
        spinner.hidden = true;
        return;
      }

      showSuccess();
      localStorage.setItem(DAY_KEY, '1');
      setTimeout(() => hidePopup(false), 3500);
    });
  }

  // SHA-256 hash for analytics (never send raw email to third parties)
  async function hashEmail(email) {
    try {
      const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(email.toLowerCase().trim()));
      return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2,'0')).join('');
    } catch { return ''; }
  }

  // ── Success state ─────────────────────────────────────
  function showSuccess() {
    modal.classList.add('is-success');
    const right = modal.querySelector('.psp-right');
    right.innerHTML = `
      <div class="psp-success-msg">
        <div class="psp-success-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12l5 5L20 7"/>
          </svg>
        </div>
        <h3>${escHtml(T('successTitle'))}</h3>
        <p>${escHtml(T('successMsg'))}</p>
      </div>
    `;
  }

  function escHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

})();
